import { Button } from "@oc-labs/wt-storybook";
import useAuth from "../../../hooks/useAuth";
import { Clock } from "lucide-react";

export default function AuthOnboardView() {
  const { logout } = useAuth()
  console.log('[ONBOARD] Render', window.location.href);

  return (
    <>
      <div className="my-12">
          <div className="mb-8 flex justify-center">
            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center text-primary animate-bounce">
              <Clock className="w-8 text-blue-800" />
            </div>
          </div>
          <h1 className="text-2xl md:text-3xl font-display font-bold text-slate-900 mb-4 text-center">
            Waiting for Access
          </h1>
          <p className="text-slate-600 leading-relaxed mb-10 max-w-sm mx-auto text-center ">
            Your account is ready! Please wait while an administrator grants you access to your company. You will be notified via email once your access is granted.
          </p>
          <div className="space-y-4 mx-6">
            <Button type="primary" target="_blank" rel="noopener noreferrer" onClick={(e) => {
              e.preventDefault();
              window.open('mailto:contact@onchainlabs.ch', '_blank');
            }}>
              Contact Support
            </Button>
            <Button type="tertiary" onClick={logout}>
              Logout
            </Button>
          </div>
      </div>
    </>
  );
}
